var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTerms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.207 0H.677C.27 0 0 .267 0 .667v14.666c0 .4.27.667.677.667h13.53c.406 0 .677-.267.677-.667V.667c0-.4-.27-.667-.677-.667zm-.676 14.667H1.354V1.333H13.53v13.334zM4.06 8h6.766c.406 0 .676-.267.676-.667v-4c0-.4-.27-.666-.676-.666H4.059c-.406 0-.676.266-.676.666v4c0 .4.27.667.676.667zm.678-4h5.412v2.667H4.737V4zm-.678 6.667h6.766c.406 0 .676-.267.676-.667s-.27-.667-.676-.667H4.059c-.406 0-.676.267-.676.667s.27.667.676.667zm6.766 2.666H4.059c-.406 0-.676-.266-.676-.666s.27-.667.676-.667h6.766c.406 0 .676.267.676.667s-.27.666-.676.666z",
    fill: "#000"
  })));
}
export default SvgIconTerms;